import React from 'react';

import PermissionCode from '@modules/roles/contantsPermissions';
import { IRouter } from '@routers/interface';

export const routerFormClubsMemberPersonal: IRouter = {
  path: '/clubs/list-members/form-member-personal/:type/:id',
  loader: React.lazy(() => import('./index')),
  exact: true,
  name: 'memberPersonal.add', //translate here for breadcrumb and sidebar
  permissionCode: PermissionCode.MEMBERS_CREATE,
};

export const routerFormClubsMemberPersonalInfo: IRouter = {
  path: '/clubs/list-members/form-member-personal/:type/:id',
  loader: React.lazy(() => import('./index')),
  exact: true,
  name: 'memberPersonal.view', //translate here for breadcrumb and sidebar
  permissionCode: PermissionCode.MEMBERS_UPDATE,
};
